import { queryOptions } from '@tanstack/react-query';
import { api } from '@/api';
import type { WorkspaceTerm } from '@/features/workspace-terms/types';
import { resourceTypeToLabel } from '@/features/workspaces/utils';

export const workspaceTermsQuery = (organizationId: string) =>
  queryOptions({
    queryKey: ['workspaceTerms', organizationId],
    queryFn: async () =>
      (await api.get<WorkspaceTerm[]>(`v1/organizations/${organizationId}/workspace-terms`)).data,
  });

export const workspaceTermWorkspacesQuery = (organizationId: string, termId: string) =>
  queryOptions({
    queryKey: ['workspaceTerms', organizationId, termId, 'workspaces'],
    queryFn: async () =>
      (
        await api.get<
          {
            id: string;
            name: string;
            projectId: string;
            resourceType: number;
            isArchived: boolean;
            createdAt: string;
            createdBy: { id: string; name: string; email: string };
          }[]
        >(`v1/organizations/${organizationId}/workspace-terms/${termId}/workspaces`)
      ).data.map(({ resourceType, ...workspace }) => ({
        ...workspace,
        type: resourceTypeToLabel(resourceType),
      })),
  });
